var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.6 78.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#baa1de;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#343a40;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-4{fill:#ffed4a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,3.45S-.44,73.5,5.84,75.74s70.05,4.49,72.75,0-.45-71.84-4-74.09S1.8-1,0,3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.46,13.11s-.33,52.27,4.36,53.94,52.26,3.35,54.27,0-.33-53.6-3-55.28S11.8,9.76,10.46,13.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.76,37s-.17,26.2,2.18,27,26.2,1.68,27.21,0S65,37.21,63.64,36.37,36.43,35.37,35.76,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15,16.77s-.11,16.39,1.36,16.92,16.39,1.05,17,0-.1-16.81-.94-17.34S15.41,15.72,15,16.77Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic3);
export default __webpack_public_path__ + "static/media/Pic3.f224605e003e5a91346b25e19444efa1.svg";
export { ForwardRef as ReactComponent };